// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fN","advertDetailContactItem__link":"c-m_fO","advertDetailContactItem__stub":"c-m_fP"};